import { render } from "./FishInfo.vue?vue&type=template&id=4ed232b9&scoped=true"
import script from "./FishInfo.vue?vue&type=script&lang=js"
export * from "./FishInfo.vue?vue&type=script&lang=js"

import "./FishInfo.vue?vue&type=style&index=0&id=4ed232b9&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4ed232b9"]])

export default __exports__